/**
 * Log — workspace-wide Log page (Iter 209 Part 2).
 * Replaces the old WorkspaceRaid page; uses the shared LogModule.
 *
 * Iter Feb 2026 R33 · The "Log dashboard" button now respects the
 * new `log.dashboard.view` permission.
 */
import PageHeader from "@/components/PageHeader";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LayoutDashboard } from "lucide-react";
import LogModule from "@/components/LogModule";
import useWorkspacePerms from "@/lib/useWorkspacePerms";

export default function Log() {
  const { hasPerm } = useWorkspacePerms();
  const canSeeDashboard = hasPerm("log.dashboard.view")
    || hasPerm("workspace.admin") || hasPerm("workspace.manage");
  return (
    <>
      <PageHeader
        eyebrow="Workspace"
        title="Log"
        description="Risks, actions, issues, concerns, information, decisions, constraints, changes, lessons, opportunities & status updates — across every client, brand, and project."
        testid="ws-log-header"
        actions={
          canSeeDashboard ? (
            <Link to="/app/log/dashboard">
              <Button variant="outline" className="rounded-none" data-testid="log-dashboard-link">
                <LayoutDashboard className="w-4 h-4 mr-2" /> Log dashboard
              </Button>
            </Link>
          ) : null
        }
      />
      <div className="px-4 sm:px-6 md:px-10 pb-10">
        <LogModule scope="workspace" testid="ws-log" />
      </div>
    </>
  );
}
